import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/alleem18'
      className='link footer__link'
    >
        A18
    </a>
  </footer>
)

export default Footer
